import React from 'react';

const TemplateDescription = ({ websiteData }) => {
    return (
        <div className="container" style={{ marginBottom: '48px' }}>
            <div
                className="p-35"
                style={{
                    backgroundColor: '#FFFFFF',
                    border: 'none',
                    borderRadius: '16px',
                    boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.1)'
                }}
            >
                <p className="text-12 mb-4" style={{ lineHeight: '1.7', color: '#000000' }}>
                    {websiteData?.storeDescription ? (
                        websiteData.storeDescription.split('\n').map((line, i) => (
                            <React.Fragment key={i}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))
                    ) : (
                        <>
                            Welcome to our store!
                            <br />
                            We are committed to providing high-quality products and exceptional customer service. Every item is carefully selected
                            to ensure quality, value, and customer satisfaction.
                        </>
                    )}
                </p>
                <ul className="list-unstyled text-12 d-flex flex-column gap-1 mb-4 ps-0" style={{ color: '#000000' }}>
                    <li className="d-flex align-items-start gap-2">
                        <span>✨</span> Premium Quality Products
                    </li>
                    <li className="d-flex align-items-start gap-2">
                        <span>📦</span> Secure & Careful Packaging
                    </li>
                    <li className="d-flex align-items-start gap-2">
                        <span>🚚</span> Fast & Reliable Shipping
                    </li>
                    <li className="d-flex align-items-start gap-2">
                        <span>💬</span> Responsive Customer Support
                    </li>
                    <li className="d-flex align-items-start gap-2">
                        <span>⭐</span> Customer Satisfaction is Our Priority
                    </li>
                </ul>
                <p className="text-12 mb-0" style={{ lineHeight: '1.7', color: '#000000' }}>
                    Thank you for choosing our store. We look forward to serving you and making your shopping experience enjoyable and
                    hassle-free.
                    <br />
                    Happy Shopping!
                </p>
            </div>
        </div>
    );
};

export default TemplateDescription;
